import * as React from "react";
import { Modal } from "antd";

export interface FileInvalidTypeModalProps {
  onOk: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
}

export default function FileInvalidTypeModal({
  onOk,
}: FileInvalidTypeModalProps) {
  return (
    <Modal
      visible={true}
      onOk={onOk}
      onCancel={onOk}
      title={"File type invalid"}
      cancelButtonProps={{ style: { display: "none" } }}
    >
      Please use a valid .jpg or .png image file.
    </Modal>
  );
}
